import { getRequest, patchRequest } from '@/plugins/api-axios'
import { getURL, userBaseUrl } from '@/utils/axios'
import { deserialise, serialise } from 'kitsu-core'

const userIncludeFull = 'employer'

export async function getCurrentUser(include = userIncludeFull) {
    let { data } = await getRequest(
        getURL({
            path: `users`,
            base: userBaseUrl,
            params: {
                include,
                'filter[isCurrent]': true,
                'filter[kind]': 'normal',
            },
        })
    )

    let res = deserialise(data).data

    return res ? res[0] : null
}

export async function patchUser(id: string, payload: any, include = userIncludeFull) {
    let { data } = await patchRequest(
        getURL({
            path: `users/${id}`,
            base: userBaseUrl,
            params: {
                include,
            },
        }),
        {},
        serialise('user', payload).data
    )

    return deserialise(data).data
}

export async function searchUsers(filters: any = {}, include = userIncludeFull) {
    let { data } = await getRequest(
        getURL({
            path: `users`,
            base: userBaseUrl,
            params: {
                include,
                ...filters,
            },
        })
    )

    return data ? deserialise(data).data : data
}
